import { Box, Container, Group, Image, rem, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import Award from './Award.png';

export default function Awards(props) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  return (
    <Box bg="gfdark.9" id="trust">
      <Container py={100} {...props}>
        <Group justify="space-around" gap={'xl'}>
          <Image maw={200} src={Award} />
          <Stack>
            <Title maw={700} align={isMobile ? 'center' : 'left'} lh={1.2} fw={500} fz={rem(48)} lts={rem(-3)} c={'white'}>
              2025 Most Emerging Innovative Islamic Finance Product
            </Title>
            <Text c="white" fz={rem(30)} fw={'lighter'} align={isMobile ? 'center' : 'left'}>
              Global Islamic Finance Awards - GIFA
            </Text>
            <Text c="gfdark.5" fz={rem(22)} fw={'lighter'} align={isMobile ? 'center' : 'left'}>
              Presented by Cambridge Islamic Finance Institute
            </Text>
          </Stack>
        </Group>
      </Container>
    </Box>
  );
}
